export default __webpack_public_path__ + "static/media/CERT4.b92e9ee3.png";